module.exports = "<md-card class=\"md-card-container\">\r\n    <md-card-title class=\"md-card-title-color\">Clients</md-card-title>\r\n    <md-card-content>\r\n        <p>\r\n            Realtime services clients across Australia and the Asia-Pacific region in the Broking, Financing and Banking industries. For more information on our clients and users of our software, please Contact Us.\r\n        </p>\r\n    </md-card-content>\r\n    <md-card-actions align=\"start\" class=\"md-card-container-actions\">\r\n        <a md-raised-button color=\"primary\" [routerLink]=\"['/contact']\">Contact us</a>\r\n    </md-card-actions>\r\n</md-card>\r\n\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/clients/clients.component.html
 ** module id = 63
 ** module chunks = 0
 **/